import "./index.css";
import { useRouteMatch } from "react-router-dom";
import React, { Suspense } from "react";
import { Spinner } from "react-bootstrap";
import getProblemForCurrentURL from "../../../../hooks/problem";

const Description = () => {
  const { params } = useRouteMatch();
  const problemFiltered = getProblemForCurrentURL(params);
  const { problem: Problem } = problemFiltered;

  return (
    <Suspense
      fallback={
        <div className="loaderIcon">
          <Spinner animation="border" />
        </div>
      }
    >
      <Problem />
    </Suspense>
  );
};

export default Description;
